import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Subject } from 'rxjs';
import { LoaderService } from '../../services/loader.service';

@Component({
    selector: 'app-page-loader',
    templateUrl: './page-loader.component.html',
    styleUrls: ['./page-loader.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PageLoaderComponent implements OnInit {

  isLoading: Subject<boolean> = this.loaderService.isDataLoading;

  constructor(private readonly loaderService: LoaderService) {
  }

  ngOnInit() {
    this.loaderService.showDataLoader();
  }

}